$(document).on('click', '.js-scrollToElem' , function() {
	const offsetMedium = $(this).hasClass('js-offsetMedium') ? 40 : 0

	var scroll_el = $(this).attr('href'); // возьмем содержимое атрибута href, должен быть селектором, т.е. например начинаться с # или .
		if ($(scroll_el).length != 0) { // проверим существование элемента чтобы избежать ошибки
			let headerHeight = $('.header .header-bottom').height()
			if($('body').width() < 769) {
				headerHeight -= 57
			}
			$('html, body').animate({ scrollTop: $(scroll_el).offset().top - headerHeight - offsetMedium}, 800); // анимируем скроолинг к элементу scroll_el
		}

	return false; // выключаем стандартное действие
});